export type ProjectOption = {id: string; name: string; prefix?: string; color?: string};

export type ProjectsViewerEdge = {
	node: {
		id: string;
		name: string;
		customProjectId?: string | null;
		projectColor?: string | null;
		client: {id: string} | null;
	} | null;
} | null;

export type ProjectsViewerEdges = ReadonlyArray<ProjectsViewerEdge> | null | undefined;

export const useClientContactProjectOptions = (
	edges: ProjectsViewerEdges,
	clientId: string | null | undefined
): ProjectOption[] => {
	if (!clientId || !edges) return [];
	const result: ProjectOption[] = [];
	for (const edge of edges) {
		const node = edge?.node;
		if (!node || node.client?.id !== clientId) continue;
		result.push({
			id: node.id,
			name: node.name,
			prefix: node.customProjectId ?? undefined,
			color: node.projectColor ?? undefined,
		});
	}
	return result;
};
